import Vue from 'vue'
import VueRouter from 'vue-router'
import HighchartsVue from 'highcharts-vue'

import Layout from './components/layout'

const routes = [
    { path: '', component: require('./components/dashboard').default, meta: { requiresAuth: true, pageTitle: 'Välkommen - Hälsoresurs företag' } },
    { path: '/employees', component: require('./components/employees/index').default, meta: { requiresAuth: true, pageTitle: 'Anställda - Hälsoresurs företag' } },
    { path: '/treatments', component: require('./components/treatments/index').default, meta: { requiresAuth: true, pageTitle: 'Behandlingar - Hälsoresurs företag' } },
    { path: '/billing', component: require('./components/billing/index').default, meta: { requiresAuth: true, pageTitle: 'Avtal - Hälsoresurs företag' } },
    { path: '/faq', component: require('./components/faq/index').default, meta: { requiresAuth: true, pageTitle: 'FAQ - Hälsoresurs företag' } },
    { path: '/managers', component: require('./components/managers/index').default, meta: { requiresAuth: true, pageTitle: 'Användarkonton - Hälsoresurs företag' } },
    { path: '/settings', component: require('./components/company/index').default, meta: { requiresAuth: true, pageTitle: 'Företagsuppgifter - Hälsoresurs företag' } },

    { path: '/login', component: require('./components/auth/login').default, meta: { requiresAuth: false, pageTitle: 'Logga in - Hälsoresurs företag' } },
    { path: '/password/email', component: require('./components/auth/forgot-password').default, meta: { requiresAuth: false, pageTitle: 'Glömt lösenord - Hälsoresurs företag' } },
    { path: '/password/reset', component: require('./components/auth/restore-password').default, meta: { requiresAuth: false, mode: 'reset', pageTitle: 'Återställ lösenord - Hälsoresurs företag' } },
    { path: '/activate', component: require('./components/auth/restore-password').default, meta: { requiresAuth: false, mode: 'activate', pageTitle: 'Aktivera ditt konto - Hälsoresurs företag' } }
]

const router = new VueRouter({
    routes,
    mode: 'history'
})

router.beforeEach((to, from, next) => {
    window.document.title = to.meta.pageTitle
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!window.auth) {
            next({
                path: '/login',
                query: { redirect: to.fullPath }
            })
        } else {
            next()
        }
    } else {
        next() // make sure to always call next()!
    }
})

Vue.use(VueRouter)
Vue.use(HighchartsVue)

Vue.mixin({
    data () {
        return {
            auth: window.auth
        }
    }
})

window.bus = new Vue()

const app = new Vue({
    router,
    components: {
        Layout
    }
}).$mount('#app')

// Browser
if (!window.matchMedia('(display-mode: standalone)').matches && (!('standalone' in window.navigator) || (('standalone' in window.navigator) && !window.navigator.standalone))) {
    var element = document.getElementById('body')
    element.classList.add('browser')
}

// Standalone PWA
if (window.matchMedia('(display-mode: standalone)').matches || (('standalone' in window.navigator) && window.navigator.standalone)) {
    var element = document.getElementById('body')
    element.classList.add('standalone')
}
